import { lazy } from 'react';

export const SettingsEvaluatingCompanyPageAsync = lazy(
    () => import('./SettingsEvaluatingCompanyPage'),
);
